import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ArchivoDto } from '@models/archivo/archivoDto.model';
import { Menu, SubMenu } from '@models/seguridad/menu/menu.model';
import { PermisoDto } from '@models/seguridad/permisos/permisoDto.model';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { LoginService } from '@services/login/login.service';
import { isFalsy } from 'utility-types';
import { Router } from '@angular/router';
import { PermisoService } from '@services/permiso/permiso.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuSettingComponent } from '@views/menu-setting/menu-setting.component';
import { ApiVersionComponent } from '@views/api-version/api-version.component';
import { DialogNotificacionesComponent } from '@views/notificaciones/dialog-notificaciones/dialog-notificaciones.component';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MenuSettingComponent, MatToolbarModule, MatTooltipModule, MenuSettingComponent, ApiVersionComponent, DialogNotificacionesComponent],
  selector: 'nav-search-perfil-logo',
  templateUrl: './nav-search-perfil-logo.component.html',
  styleUrls: ['./nav-search-perfil-logo.component.css']
})
export class NavSearchPerfilLogoComponent implements OnInit, OnDestroy {

  archivo: ArchivoDto = new ArchivoDto
  @ViewChild("inputSearch") input?: ElementRef;
  hidden = false;
  matTooltip?: string;
  menues!: Menu[]
  value = 'Buscar';
  user!: UsuarioDto;
  permisosDto!: PermisoDto[] | null;
  private permisosSubscription?: Subscription;

  constructor(
    private loginService: LoginService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private permisoService: PermisoService
  ) {
  }

  ngOnInit(): void {
    this.user = this.loginService.getCurrentUser();
    this.archivo.id = 1;

    if (this.user) {
      this.matTooltip = `Nombre y Apellido: &#13s; ${this.user.nombre + ' ' + this.user.apellido}. &#13; Usuario: &#13; ${this.user.userName}`;

      // Intentar cargar permisos del cache
      this.loadPermisosFromCache();

      // Suscribirse a cambios en permisos
      this.permisosSubscription = this.permisoService.permisosObservable
        .pipe(
          filter(permisos => permisos !== null && permisos.length > 0)
        )
        .subscribe(permisos => {
          if (permisos) {
            this.permisosDto = permisos;
            this.getPermisos(permisos);
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.permisosSubscription?.unsubscribe();
  }

  private loadPermisosFromCache(): void {
    if (!this.user?.rol?.id) return;

    // Intentar obtener permisos del cache
    const cachedPermisos = this.permisoService.getPermisosCache(this.user.rol.id);

    if (cachedPermisos && cachedPermisos.length > 0) {
      this.permisosDto = cachedPermisos;
      this.getPermisos(cachedPermisos);
    } else {
      // Si no hay permisos en cache, cargarlos desde el servicio
      this.permisoService.getPermisosPorRol(this.user.rol.id).subscribe({
        next: (permisos) => {
          this.permisosDto = permisos;
          this.getPermisos(permisos);
        },
        error: (error) => {
          console.error('Error cargando permisos en navegación:', error);
        }
      });
    }
  }

  getPermisos(permisosDto: PermisoDto[]) {
    if (!permisosDto || permisosDto.length === 0) return;

    // Reiniciar menús
    this.menues = [];

    permisosDto.forEach(element => {
      if (isFalsy(this.menues))
        this.menues = []

      let menu = isFalsy(element.casoUso.menu) ? undefined : this.menues.find(x => x.displayName === element.casoUso.menu.descripcion) as Menu

      if (isFalsy(menu)) {
        menu = this.addMenu(element)
        if (!isFalsy(menu)) {
          if (menu.submenues.find(x => x.displayName === element.casoUso.descripcion)) {
            let subMenu = menu.submenues.find(x => x.displayName === element.casoUso.descripcion) as SubMenu
            subMenu = this.addSubMenu(element)
            menu.submenues.push(subMenu)
          }
          else {
            let subMenu = this.addSubMenu(element)
            menu.submenues.push(subMenu)
          }
          this.menues.push(menu)
        }
      }
      else {
        if (menu.submenues.find(x => x.displayName != element.casoUso.descripcion)) {
          let subMenu = menu.submenues.find(x => x.displayName === element.casoUso.descripcion) as SubMenu
          if (subMenu == undefined) {
            let subMenu = this.addSubMenu(element)
            menu.submenues.push(subMenu)
          }
        }
      }
    });
  }

  addMenu(element: PermisoDto) {
    let menu!: Menu
    if (element.casoUso.menu) {
      menu = new Menu
      menu.displayName = isFalsy(element.casoUso.menu.descripcion) ? "" : element.casoUso.menu.descripcion
      menu.iconName = isFalsy(element.casoUso.menu.icon) ? "" : element.casoUso.menu.icon
      menu.route = isFalsy(element.casoUso.menu.path) ? "" : element.casoUso.menu.path
    }
    return menu
  }

  addSubMenu(element: PermisoDto) {
    let subMenu!: SubMenu
    if (element.casoUso) {
      subMenu = new SubMenu
      subMenu.displayName = isFalsy(element.casoUso.descripcion) ? "" : element.casoUso.descripcion
      subMenu.iconName = isFalsy(element.casoUso.icon) ? "" : element.casoUso.icon
      subMenu.route = isFalsy(element.casoUso.path) ? "" : element.casoUso.path
    }
    return subMenu
  }

  trackByItems(index: number, item: any): any { return item; }
}
